import { errorLink } from "@/shared/services/apollo-clients/links/error-link";
import { rateLimitLink } from "@/shared/services/apollo-clients/links/rate-limit-link";
import { ApolloClient, createHttpLink } from "@apollo/client/core";
import { clientCache } from "./client-cache";

const httpLink = createHttpLink({
    uri: "/graphql/public",
});

export const publicClient = new ApolloClient({
    link: errorLink.concat(rateLimitLink).concat(httpLink),
    connectToDevTools: false,
    cache: clientCache,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: "network-only",
        },
        query: {
            fetchPolicy: "network-only",
        },
    },
});
